import * as Definitions from './Definitions';
import { Observable } from 'rxjs';
import { Effects } from '../';
export const description = '';
export const method = 'POST';
export const operationId = 'workwearExpressQuickQuoteContactServiceV1ContactPost';
export const path = '/V1/quick-quote';
export interface Body {
    contactData: Definitions.WorkwearExpressQuickQuoteDataQuickQuoteDataInterface;
}
export type Response = Response200 | ResponseDefault;
export type Response200 = boolean;
export type ResponseDefault = Definitions.ErrorResponse;
type MinimalEffects = Pick<Effects, 'apiUrl' | 'restHeaders' | 'postJSON'>;
export function execute(body: Body, effects: MinimalEffects): Observable<Response200> {
    return effects.postJSON(effects.apiUrl(operationId)(path, undefined), body, effects.restHeaders({})) as any;
}
